import { render, staticRenderFns } from "./melody-15.vue?vue&type=template&id=1019f80b&scoped=true"
import script from "./melody-15.vue?vue&type=script&lang=js"
export * from "./melody-15.vue?vue&type=script&lang=js"
import style0 from "./melody-15.vue?vue&type=style&index=0&id=1019f80b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1019f80b",
  null
  
)

export default component.exports